import { useEffect, useMemo, useState } from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Floating } from "../components/Floating";
import { LeadDialog } from "../components/LeadCapture";
import { AuthDialog } from "../components/AuthDialog";
import { Township } from "../components/Township";
import { YeidaPlots } from "../components/YeidaPlots";
import { AirportMobility } from "../components/AirportMobility";
import { LandingHero } from "../components/landing/LandingHero";
import { LandingBlocks } from "../components/landing/LandingBlocks";
import { LandingFaq } from "../components/landing/LandingFaq";
import { LANDING_PAGES } from "../data/landing";
import { PHONE, EMAIL, REGISTERED_ADDRESS, SITE_URL } from "../data/site";
import { useLenis } from "../hooks/useLenis";
import { useSeo } from "../hooks/useSeo";

const DIALOGS = {
  inventory: { title: "Get Today's GYC Inventory", context: "Live apartments, plots, villas, commercial and verified resale - sent to you directly.", leadType: "inventory" },
  yeida: { title: "YEIDA Scheme Alerts", context: "We will notify you when the next YEIDA plot scheme opens, with brochure, rates and draw dates.", leadType: "yeida-alert" },
  advisor: { title: "Speak with a Radiance Advisor", context: "Share your brief - we respond with honest, corridor-level perspective.", leadType: "advisor" },
};

export default function Landing({ slug }) {
  const page = LANDING_PAGES[slug];
  const [dialog, setDialog] = useState(null);
  useLenis();

  useEffect(() => { window.scrollTo(0, 0); }, [slug]);

  const jsonLd = useMemo(() => ({
    "@context": "https://schema.org",
    "@graph": [
      { "@type": "RealEstateAgent", name: "Radiance Realtors", telephone: PHONE, email: EMAIL, address: REGISTERED_ADDRESS, areaServed: "Yamuna Expressway, Greater Noida, Uttar Pradesh", url: SITE_URL },
      { "@type": "FAQPage", mainEntity: page.faqs.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })) },
      { "@type": "BreadcrumbList", itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
        { "@type": "ListItem", position: 2, name: page.tag, item: `${SITE_URL}${page.path}` },
      ] },
    ],
  }), [page]);

  useSeo({ title: page.title, description: page.description, keywords: page.keywords, path: page.path, image: page.image, jsonLd });

  const openCta = () => setDialog(page.cta.dialog);
  const cfg = dialog ? DIALOGS[dialog] : DIALOGS.advisor;

  return (
    <div className="grain" data-testid={`landing-page-${slug}`}>
      <Navbar onAdvisor={() => setDialog("advisor")} />
      <main>
        <LandingHero page={page} onCta={openCta} />
        <LandingBlocks blocks={page.blocks} />
        {page.embed === "township" && <Township />}
        {page.embed === "yeida" && <YeidaPlots onAlert={() => setDialog("yeida")} />}
        {page.embed === "mobility" && <AirportMobility />}
        <LandingFaq page={page} onCta={openCta} />
      </main>
      <Footer />
      <Floating />
      <AuthDialog />
      <LeadDialog open={!!dialog} onClose={() => setDialog(null)} leadType={cfg.leadType} title={cfg.title} context={cfg.context} />
    </div>
  );
}
